require('./helpers');
require('./notify');
require('./tippy');

window.createAlert = function (severity, content) {
    let color = '';

    if (typeof content !== 'string') {
        let message = '';

        for (let key of Object.keys(content)) {
            let errors = content[key].map(error => `<li>${error}</li>`).join();
            message += `<div><ul>${errors}</ul></div>`;
        }

        content = message;
    }

    if (severity === 'info') {
        color = 'blue';
    } else if (severity === 'warning') {
        color = 'yellow';
    } else if (severity === 'error') {
        color = 'red';
    }

    return `
        <div class="bg-${color}-50 border-l-4 border-${color}-400 p-4 mt-3" x-data="{}">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center leading-none">
              <i class="far fa-exclamation-triangle text-${color}-400"></i>
            </div>
            <div class="ml-3">
              <p class="text-sm text-${color}-700">
                ${content}
              </p>
            </div>
            <div class="ml-auto pl-3">
              <div class="-mx-1.5 -my-1.5">
                <button type="button" @click="$el.remove()" class="inline-flex bg-${color}-50 rounded-md p-1.5 text-${color}-500 hover:bg-${color}-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-${color}-50 focus:ring-${color}-600">
                  <span class="sr-only">Dismiss</span>
                  <svg class="h-5 w-5" x-description="Heroicon name: solid/x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
    `;
};

window.renderToContainer = function (alert, container) {
    container.insertAdjacentHTML('beforeend', alert);
};

window.clearContainer = function (container) {
    container.innerHTML = '';
};

window.api = function (method, uri, data = [], csrf = '') {
    let request = fetch(uri, {
        method,
        headers: {
            'X-CSRF-Token': csrf,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    });
    // let request = axios[method](uri, data).then(res => res.data);

    let wrapper = {
        errorContainer: function (selector) {
            function error(errors) {
                let container = document.querySelector(selector);
                clearContainer(container);
                renderToContainer(createAlert('error', errors), container);
            }

            request = request.then(async response => {
                let data = await response.json();
                if (!response.ok) {
                    let error = new Error('Test');
                    error.data = data;
                    throw error;
                }
                return data;
            }).catch(err => {
                error(err.data?.errors ?? err.data?.message ?? 'No error message found.');
                return err;
            });

            return wrapper;
        },
        onSuccess(func) {
            request = request.then(async response => {
                if (response instanceof Error) {
                    return response;
                }

                await func(response);
                return response;
            });
            return wrapper;
        },
        then(onFullfilled, onRejected = null) {
            request = request.then(onFullfilled, onRejected);
            return wrapper;
        },
        catch(func) {
            request = request.catch(func);
            return wrapper;
        },
    };

    return wrapper;
};

window.Components = {};
window.Components.menu = function (t = {open: !1}) {
    return {
        init() {
            this.items = Array.from(this.$el.querySelectorAll('[role="menuitem"]')),
                this.$watch('open', (() => {
                        this.open && (this.activeIndex = -1);
                    }
                ));
        },
        activeDescendant: null,
        activeIndex: null,
        items: null,
        open: t.open,
        focusButton() {
            this.$refs.button.focus();
        },
        onButtonClick() {
            this.open = !this.open,
            this.open && this.$nextTick((() => {
                    this.$refs['menu-items'].focus();
                }
            ));
        },
        onButtonEnter() {
            this.open = !this.open,
            this.open && (this.activeIndex = 0,
                this.activeDescendant = this.items[this.activeIndex].id,
                this.$nextTick((() => {
                        this.$refs['menu-items'].focus();
                    }
                )));
        },
        onArrowUp() {
            if (!this.open)
                return this.open = !0,
                    this.activeIndex = this.items.length - 1,
                    void (this.activeDescendant = this.items[this.activeIndex].id);
            0 !== this.activeIndex && (this.activeIndex = -1 === this.activeIndex ? this.items.length - 1 : this.activeIndex - 1,
                this.activeDescendant = this.items[this.activeIndex].id);
        },
        onArrowDown() {
            if (!this.open)
                return this.open = !0,
                    this.activeIndex = 0,
                    void (this.activeDescendant = this.items[this.activeIndex].id);
            this.activeIndex !== this.items.length - 1 && (this.activeIndex = this.activeIndex + 1,
                this.activeDescendant = this.items[this.activeIndex].id);
        },
        onClickAway(t) {
            if (this.open) {
                const e = ['[contentEditable=true]', '[tabindex]', 'a[href]', 'area[href]', 'button:not([disabled])', 'iframe', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])'].map((t => `${t}:not([tabindex='-1'])`)).join(',');
                this.open = !1,
                t.target.closest(e) || this.focusButton();
            }
        },
    };
};
window.Components.popover = function ({open: t = !1, focus: e = !1} = {}) {
    const i = ['[contentEditable=true]', '[tabindex]', 'a[href]', 'area[href]', 'button:not([disabled])', 'iframe', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])'].map((t => `${t}:not([tabindex='-1'])`)).join(',');
    return {
        __type: 'popover',
        open: t,
        init() {
            e && this.$watch('open', (t => {
                    t && this.$nextTick((() => {
                            !function (t) {
                                const e = Array.from(t.querySelectorAll(i));
                                !function t(i) {
                                    void 0 !== i && (i.focus({
                                        preventScroll: !0,
                                    }),
                                    document.activeElement !== i && t(e[e.indexOf(i) + 1]));
                                }(e[0]);
                            }(this.$refs.panel);
                        }
                    ));
                }
            ));
            let t = i => {
                    if (!document.body.contains(this.$el))
                        return void window.removeEventListener('focus', t, !0);
                    let n = e ? this.$refs.panel : this.$el;
                    if (this.open && i.target instanceof Element && !n.contains(i.target)) {
                        let t = this.$el;
                        for (; t.parentNode;)
                            if (t = t.parentNode,
                            t.__x instanceof this.constructor) {
                                if ('popoverGroup' === t.__x.$data.__type)
                                    return;
                                if ('popover' === t.__x.$data.__type)
                                    break;
                            }
                        this.open = !1;
                    }
                }
            ;
            window.addEventListener('focus', t, !0);
        },
        onEscape() {
            this.open = !1,
            this.restoreEl && this.restoreEl.focus();
        },
        onClosePopoverGroup(t) {
            t.detail.contains(this.$el) && (this.open = !1);
        },
        toggle(t) {
            this.open = !this.open,
                this.open ? this.restoreEl = t.currentTarget : this.restoreEl && this.restoreEl.focus();
        },
    };
};
window.Components.collapse = function () {
    return {
        __type: 'collapse',
        expanded: null,
        init() {
            const elem = this.$refs.content;

            // We add the hidden attribute and CSS class via Alpine's init function
            // so that content is not hidden if the JS fails to execute. The downside
            // of this is a layout-shift issue and a flash of content appearing then
            // disappearing as the page loads then the JS executes. The balance
            // between progressive enhancement and layout-shift issues is tricky!
            elem.hidden = true;
            elem.classList.add('collapse__content');
        },
        toggle() {
            const elem = this.$refs.content;

            if (this.expanded) {
                // Remove the --collapse-height custom property so the browser uses
                // the fallback value of 0.
                elem.style.removeProperty('--collapse-height');
                elem.addEventListener(
                    'transitionend',
                    (e) => {
                        // We need to make sure the event hasn't come from a child element
                        // and bubbled up to our element.
                        if (e.target === elem) {
                            // Mark the element as hidden so its contents will be
                            // hidden from assistive tech like screen readers or
                            // keyboard navigation.
                            elem.hidden = true;
                            this.expanded = false;
                        }
                    },
                    {
                        once: true,
                    },
                );
            } else {
                // Unhide our element so we can calculate its dimensions.
                // It will still be visually hidden because of the maxHeight
                // of 0.
                elem.hidden = false;
                // Set a --collapse-height property that matches the elements height.
                // This will cause the browser to animate the opening of the
                // element.
                elem.style.setProperty('--collapse-height', `${elem.scrollHeight}px`);
                elem.addEventListener(
                    'transitionend',
                    (e) => {
                        // We need to make sure the event hasn't come from a child element
                        // and bubbled up to our element.
                        if (e.target === elem) {
                            this.expanded = true;
                        }
                    },
                    {
                        once: true,
                    },
                );
            }
        },
        updateHeight() {
            // A function to update the custom property on window resize, to avoid
            // clipping content if the scrollHeight value of the element changes.
            if (this.expanded) {
                const elem = this.$refs['content'];
                elem.style.setProperty('--collapse-height', `${elem.scrollHeight}px`);
            }
        },
    };
};

window.Components.ContactUs = function (url, csrf, actor = '') {
    return {
        FILES_COUNT_MAX: 10,
        FILE_SIZE_MAX: 10_240_000,
        drag: 0,
        isSending: false,
        files: [],
        phone: '',
        subject: '',
        message: '',
        sendCopy: false,
        checkbox: false,
        errors: [],
        showSuccessTicketNr: '',
        attach(fileList) {
            this.drag--;
            fileList = [...fileList];
            if ((this.files.length + fileList.length) > this.FILES_COUNT_MAX) {
                alert('You can not add more than 10 attachments.');
                return;
            }
            for (let file of fileList) {
                if (file.size > this.FILE_SIZE_MAX) {
                    alert('You can only add individual files of up to 10MB');
                    return;
                }
            }
            this.files.push(...fileList);
        },
        submit() {
            let data = new FormData();
            data.append('phone', this.phone);
            data.append('subject', this.subject);
            data.append('message', this.message);
            data.append('send_copy', this.sendCopy ? 1 : 0);
            data.append('checkbox', this.checkbox ? 1 : 0);
            data.append('actor', actor);

            this.files.forEach((file) => {
                data.append('attachments[]', file);
            });

            this.isSending = true;
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': csrf,
                },
                body: data,
            })
                .then(async response => {
                    if (response.ok) {
                        this.clear();
                        notify.success('Email Support Ticket sent.');
                        this.showSuccessTicketNr = (await response.json())?.ticket;
                    } else if (response.status === 422) {
                        this.errors = Object.values((await response.json())?.errors ?? {}).flat();
                        console.log(this.errors);
                    } else {
                        let error = 'Unknown error. Please contact rcodezero@ipcom.at directly.';
                        this.errors = [error];
                        notify.error(error);
                    }
                })
                .finally(() => this.isSending = false);
        },
        clear() {
            this.files = [];
            this.phone = '';
            this.subject = '';
            this.message = '';
            this.sendCopy = false;
            this.checkbox = false;
            this.errors = [];
        },
    };
};
